import LazyLoad from "vanilla-lazyload";
import polyfill from "./polyfill";
import Splide from "@splidejs/splide";
import Isolde from "isolde";
// star-rating-svg et flatpickr : chargés à la demande (import()) plus bas

const main = {
  load() {
    $(function () {
      const homeSlider = document.querySelector(".HomeSlider.splide");

      if (homeSlider) {
        const slides = homeSlider.querySelectorAll(".splide__slide");

        // Lecture des options depuis les data-attributes (définis dans homepage-slider.twig)
        const doAutoplay =
          homeSlider.dataset.autoplay === "1" && slides.length > 1;
        const doArrows = homeSlider.dataset.arrows !== "0" && slides.length > 1;
        const doPagination = homeSlider.dataset.pagination !== "0";

        const splide = new Splide(homeSlider, {
          type: slides.length > 1 ? "loop" : "slide",
          arrows: doArrows,
          pagination: doPagination,
          autoplay: doAutoplay,
        }).mount();

        // Gestion click-to-play : remplacement de la façade par l'iframe avec autoplay
        homeSlider
          .querySelectorAll(".HomeSlider-videoFacade")
          .forEach(function (facade) {
            facade.addEventListener("click", function () {
              const type = this.dataset.videoType;
              const id = this.dataset.videoId;
              let src = "";

              if (type === "vimeo") {
                src =
                  "https://player.vimeo.com/video/" +
                  id +
                  "?autoplay=1&loop=1&byline=0&title=0";
              } else {
                src =
                  "https://www.youtube-nocookie.com/embed/" +
                  id +
                  "?autoplay=1&rel=0&modestbranding=1";
              }

              const iframe = document.createElement("iframe");
              iframe.src = src;
              iframe.setAttribute("frameborder", "0");
              iframe.setAttribute("allow", "autoplay; fullscreen");
              iframe.setAttribute("allowfullscreen", "");
              iframe.className = "HomeSlider-videoIframe";

              this.replaceWith(iframe);

              // Pause l'autoplay du slider pendant la lecture vidéo
              if (splide.Components.Autoplay) {
                splide.Components.Autoplay.pause();
              }
            });
          });
      }

      // =========================================================================
      // Custom select (CF7 compatible)
      // - Supprime la redirection window.location.href
      // - Déclenche un event "change" pour que CF7 capte la valeur
      // =========================================================================
      let x, i, j, l, ll, selElmnt, a, b, c;

      function closeAllSelect(elmnt) {
        let x, y, i;
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");

        for (i = 0; i < y.length; i++) {
          if (elmnt !== y[i]) {
            y[i].classList.remove("select-arrow-active");
            y[i].classList.remove("select-selected-bottom-square");
          }
        }

        for (i = 0; i < x.length; i++) {
          if (elmnt !== x[i].previousSibling) {
            x[i].classList.add("select-hide");
          }
        }
      }

      x = document.getElementsByClassName("custom-select");
      l = x.length;

      for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        if (!selElmnt) continue;

        // Nettoyage si déjà initialisé (re-render CF7 ou reload partiel)
        const oldSelected = x[i].querySelector(".select-selected");
        const oldItems = x[i].querySelector(".select-items");
        if (oldSelected) oldSelected.remove();
        if (oldItems) oldItems.remove();

        ll = selElmnt.length;

        a = document.createElement("DIV");
        a.setAttribute(
          "class",
          "select-selected select-selected-bottom-rounded",
        );
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);

        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");

        // j=1 : on ne rend pas cliquable le placeholder (option 0)
        for (j = 1; j < ll; j++) {
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;

          c.addEventListener("click", function () {
            let s, h, y, k;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            h = this.parentNode.previousSibling;

            for (let i = 0; i < s.length; i++) {
              if (s.options[i].innerHTML === this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;

                y = this.parentNode.getElementsByClassName("same-as-selected");
                for (k = 0; k < y.length; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");

                // IMPORTANT : CF7 capte la valeur via change
                s.dispatchEvent(new Event("change", { bubbles: true }));

                break;
              }
            }

            // Referme le dropdown
            h.click();
          });

          b.appendChild(c);
        }

        x[i].appendChild(b);

        a.addEventListener("click", function (e) {
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
          this.classList.toggle("select-selected-bottom-square");
        });

        // Si le select natif change (reset CF7, autofill...), on sync le texte affiché
        selElmnt.addEventListener("change", function () {
          const selectedText =
            this.options[this.selectedIndex]?.innerHTML || "";
          const display =
            this.closest(".custom-select")?.querySelector(".select-selected");
          if (display) display.innerHTML = selectedText;
        });
      }

      document.addEventListener("click", closeAllSelect);

      // =========================================================================
      // Isolde (safe)
      // =========================================================================
      const canUseIsolde =
        !document.body.classList.contains("single-galerie") &&
        !document.body.classList.contains("template-page-galerie");

      if (canUseIsolde) {
        const isoldeContainer =
          document.querySelector(".searchform") ||
          document.querySelector(".isolde") ||
          document.querySelector("[data-isolde]");

        if (isoldeContainer) {
          try {
            new Isolde();
          } catch (e) {
            console.warn("Isolde init failed:", e);
          }
        }
      }

      // =========================================================================
      // Star rating
      // =========================================================================
      if ($(".rated-notation").length) {
        Promise.all([
          import(/* webpackChunkName: "star-rating" */ "star-rating-svg/src/jquery.star-rating-svg.js"),
          import(/* webpackChunkName: "star-rating" */ "star-rating-svg/src/css/star-rating-svg.css"),
        ]).then(() => {
          $(".rated-notation").starRating({
            totalStars: 5,
            starShape: "rounded",
            starSize: 15,
            emptyColor: "lightgrey",
            hoverColor: "#ffc107",
            activeColor: "#ffc107",
            useGradient: false,
            readOnly: true,
          });
        });
      }

      // =========================================================================
      // Flatpickr
      // =========================================================================
      if (document.querySelector(".dates")) {
        Promise.all([
          import(/* webpackChunkName: "flatpickr" */ "flatpickr"),
          import(/* webpackChunkName: "flatpickr" */ "flatpickr/dist/flatpickr.css"),
        ]).then(([{ default: flatpickr }]) => {
          flatpickr(".dates", {
            enableTime: true,
            dateFormat: "d-m-Y",
          });
        });
      }
      // =========================================================================
      // Modales
      // =========================================================================
      //   const modalButtons = document.querySelectorAll(".js-btn-modal");
      //   const modals = document.querySelectorAll(".js-modal");
      //   const closeButtons = document.querySelectorAll(".js-close-btn");
      //   const overlay = document.getElementById("overlay");

      //   let scrollY = 0;

      //   if (modalButtons.length && overlay) {
      //     modalButtons.forEach((button) => {
      //       button.addEventListener("click", function (event) {
      //         event.preventDefault();
      //         event.stopPropagation();

      //         const modalId = this.getAttribute("data-id");
      //         if (!modalId) return;

      //         const modal = document.getElementById(modalId);
      //         if (!modal) return;

      //         scrollY = window.scrollY;

      //         document.body.style.top = `-${scrollY}px`;
      //         document.body.classList.add("no-scroll");

      //         modal.style.display = "flex";
      //         overlay.style.display = "block";
      //       });
      //     });

      //     const closeModal = (modal) => {
      //       if (modal) modal.style.display = "none";
      //       overlay.style.display = "none";

      //       document.body.classList.remove("no-scroll");
      //       document.body.style.top = "";
      //       window.scrollTo(0, scrollY);
      //     };

      //     closeButtons.forEach((button) => {
      //       button.addEventListener("click", function (event) {
      //         event.preventDefault();
      //         event.stopPropagation();

      //         const modal = this.closest(".Modal");
      //         closeModal(modal);
      //       });
      //     });

      //     window.addEventListener("click", (event) => {
      //       modals.forEach((modal) => {
      //         if (event.target === modal) {
      //           closeModal(modal);
      //         }
      //       });
      //     });
      //   }
      main.loaded();
    });
  },

  loaded() {
    // =========================================================================
    // Mapplic (Shadow DOM) - Custom popup styles
    // =========================================================================
    (function initMapplicShadowStyles() {
      const css = `
                .mapplic-element,
                .mapplic-container,
                .mapplic-map {
                    background: #FFFFFF;
                }

                .mapplic-element {
                    max-width: 1200px;
                    margin: 0 auto;
                }
                
                .mapplic-tooltip.mapplic-popup{
                  display:flex !important;
                  flex-direction:column !important;
                  max-width:360px !important;
                  max-height:none !important;
                  min-width: 310px;
                  z-index: 999;
                }

                .mapplic-tooltip  {
                    border-radius: 0px !important;
                }
               
                .mapplic-popup-image{
                  width:100% !important;
                  height:200px;
                  overflow:hidden;
                  border-radius: 0px !important;
                }

                .mapplic-popup-image img{
                  width:100% !important;
                  height:100% !important;
                  object-fit:cover;
                  display:block;
                }

                
                .mapplic-popup-content{
                  padding: 14px 16px;
                }

                .mapplic-popup-title{
                  margin:0 0 10px 0;
                }

                .mapplic-popup-body{
                  overflow:visible !important;
                  max-height:none !important;
                }

                .mapplic-popup-body ul {
                    margin-left: 0;
                    padding-left: 1.25rem;
                }

                .mapplic-popup-close {
                    background-color: #DAA9CB;
                    border-radius: 50%;
                    padding: 4px;
                }

                .mapplic-popup-close svg {
                    stroke: #ffffff;
                }
            `;

      function injectInto(el) {
        if (!el || !el.shadowRoot) return;
        if (el.shadowRoot.querySelector("style[data-mapplic-custom]")) return;

        const style = document.createElement("style");
        style.setAttribute("data-mapplic-custom", "1");
        style.textContent = css;
        el.shadowRoot.appendChild(style);
      }

      function tryInject() {
        document.querySelectorAll("mapplic-map").forEach(injectInto);
      }

      // Première tentative
      tryInject();

      // Si Mapplic se monte après, on observe le DOM
      const obs = new MutationObserver(tryInject);
      obs.observe(document.documentElement, { childList: true, subtree: true });
    })();

    // =========================================================================
    // Polyfills
    // =========================================================================
    polyfill.load();

    // =========================================================================
    // Page popup AJAX
    // =========================================================================
    const $popup = $("#popup");

    $(document).on("click", ".open-popup", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (typeof wp_data === "undefined" || !wp_data.ajax_url) {
        console.warn("wp_data.ajax_url manquant, popup désactivé.");
        return;
      }

      $.ajax({
        method: "POST",
        url: wp_data.ajax_url,
        data: {
          action: "post_content",
          ID: $(this).data("post-id"),
          security: wp_data.security,
        },
      })
        .done(function (response) {
          $popup.addClass("open");
          $("html").addClass("no-scroll");
          $popup.find(".popup-content").html(response);

          $(".close-button")
            .off("click")
            .on("click", function () {
              $("#popup").removeClass("open");
              $("html").removeClass("no-scroll");
            });
        })
        .fail(function () {
          console.error("Error getting post content");
        });
    });

    // =========================================================================
    // LazyLoad
    // =========================================================================
    if (document.querySelector(".lazy")) {
      new LazyLoad();
    }
  },
};

export default main;
